import { Platform } from "react-native";
import { UserLoggedInNavigatorScreenProps } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { RoutineDetailStack } from "./RoutineDetailStack";
import { HeaderButton } from "../../../components";
import { RoutineDetailScreen } from "./RoutineDetailScreen";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import { TaskAllIssuesScreen } from "./TaskAllIssuesScreen";
import { useTheme } from "arkh";
import { RoutinesOccasionsFollowupScreen } from "../RoutineOccasionFollowup/RoutineOccasionFollowup";
import { BottomSheetModalProvider } from "@gorhom/bottom-sheet";

export function RoutineDetailNavigator(
  props: UserLoggedInNavigatorScreenProps<"RoutineDetail">
) {
  const intl_tokens = useIntlTokens();
  const theme = useTheme();

  return (
    <BottomSheetModalProvider>
      <RoutineDetailStack.Navigator>
        <RoutineDetailStack.Screen
          name="RoutineDetailMain"
          options={({ route, navigation }) => ({
            presentation: "modal",
            headerLeft:
              Platform.OS === "android"
                ? undefined
                : () => (
                    <HeaderButton type="CLOSE" onPress={navigation.goBack} />
                  ),
            headerShown: true,
            headerTitle: route.params.routineTitle,
          })}
          component={RoutineDetailScreen}
        />

        <RoutineDetailStack.Screen
          name="TaskAllIssues"
          options={({ route }) => ({
            presentation: "card",
            headerBackTitle: intl_tokens.Back,
            headerShown: true,
            headerShadowVisible: false,
            headerTitle: route.params.taskTitle,
          })}
          component={TaskAllIssuesScreen}
        />
        <RoutineDetailStack.Screen
          name="RoutinesOcassionsFollowup"
          options={({ route }) => ({
            presentation: "card",
            headerShown: true,
            headerTitle: route.params.routineTitle,
            headerBackTitle: intl_tokens.Back,
            headerStyle: {
              backgroundColor: theme.background,
            },
            headerHideShadow: true,
          })}
          component={RoutinesOccasionsFollowupScreen}
        />
      </RoutineDetailStack.Navigator>
    </BottomSheetModalProvider>
  );
}
